var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNorSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20673 9.56525C2.55388 10.8533 3.319 11.9698 4.34786 12.7603V9.56525H2.20673Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47827 13.9772C7.65026 13.992 7.82419 14 8.00001 14C10.7722 14 13.1048 12.1198 13.7933 9.56525H7.47827V13.9772Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7933 6.43477C13.1048 3.88018 10.7722 2 8.00001 2C7.82419 2 7.65026 2.00802 7.47827 2.02283V6.43477H13.7933Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34786 3.23972C3.319 4.03026 2.55388 5.14666 2.20673 6.43476H4.34786V3.23972Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9492 7.21739H6.69568H6.69566V2.14261C6.14117 2.26556 5.61549 2.46485 5.13043 2.72953V7.21734V7.21737H2.05079C2.01739 7.47356 2 7.73475 2 7.99999C2 8.26523 2.01739 8.52642 2.05079 8.78259H5.13041H5.13043V13.2704C5.61549 13.5351 6.14117 13.7344 6.69566 13.8574V8.78266V8.78262H13.9492C13.9826 8.52642 14 8.26523 14 7.99999C14 7.73475 13.9826 7.47356 13.9492 7.21739Z",
    fill: "#0052B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorSm);
export default __webpack_public_path__ + "static/media/NOR-SM.f937a80dcfe29bc18b5d7f0d8a881afe.svg";
export { ForwardRef as ReactComponent };